import React, { FC } from 'react'

export const CardDate: FC = ({ children }): JSX.Element => <div className='card-container__date'>{children}</div>
